import { animateAttribute, setCss, swalAlert } from '../functions.js';

export default class CarouselElement extends HTMLElement {

    #delay = 5000;
    #swiper = null;
    #playCircle = null;

    connectedCallback() {

        this.#playCircle   = this.querySelector('play-circle');

        const swiperElement = document.querySelector('swiper-container');
        this.#swiper = swiperElement.swiper; 
    
        swiperElement.addEventListener('swiperslidechange', (event) => {
            if (this.#swiper.autoplay.running) {
                this.#playCircle && this.#playCircle.play(this.#delay);
            }
        });
        swiperElement.addEventListener('swiperautoplayStop', (event) => {
            this.#playCircle && this.#playCircle.setPaused();
        });

        this.#playCircle && this.#playCircle.addEventListener('click', () => {
            if (this.#swiper.autoplay.running) {
                this.#playCircle.setPlaying();
                this.#playCircle.pause();
                this.#swiper.autoplay.stop();
            } else {
                this.#playCircle.setPaused();
                this.#playCircle.play(this.#delay);
                this.#swiper.autoplay.start();
            }
        });

        customElements.whenDefined('sl-progress-ring').then(() => {
            this.#playCircle && this.#playCircle.play(this.#delay);
        });
        
    }
};

class PlayCircle extends HTMLElement {

    #progressRing = null;
    #pauseSvg = null;
    #playSvg = null;

    connectedCallback() {
        this.innerHTML = `
            <sl-progress-ring 
                class="playcircle__ring"
                value="0"
                style="  "></sl-progress-ring>

            <svg class="playcircle__play" style="display:none" width="14px" height="20px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 14 20" xml:space="preserve" style="margin-top: 2px; margin-left: 1px;">
                <path d="M-0.1,0v20l14-10L-0.1,0z M1.6,3.2l9.5,6.7l-9.5,6.8C1.6,16.7,1.6,3.2,1.6,3.2z"></path>
            </svg>

            <svg class="playcircle__pause" width="10px" height="16px" viewBox="0 0 10 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin-left: 1px; margin-top: -2px;">
                <g stroke="none" stroke-width="1">
                    <g transform="translate(-473.000000, -299.000000)" fill-rule="nonzero">
                        <g transform="translate(473.000000, 299.000000)"><polygon points="0 0 2 0 2 16 0 16"></polygon><polygon points="8 0 10 0 10 16 8 16"></polygon></g>
                    </g>
                </g>
            </svg>
        `;

        this.#progressRing = this.querySelector('sl-progress-ring');
        this.#pauseSvg     = this.querySelector('.playcircle__pause');
        this.#playSvg      = this.querySelector('.playcircle__play');

    }

    setPaused() {
        setCss(this.#playSvg, 'display', 'none');
        setCss(this.#pauseSvg, 'display', 'block');
    }

    setPlaying() {
        setCss(this.#pauseSvg, 'display', 'none');
        setCss(this.#playSvg, 'display', 'block');
    }

    pause() {
        this.#progressRing.style.setProperty('--indicator-transition-duration', '0s');
        setTimeout(() => {
            this.#progressRing.setAttribute('value', 0);
        }, 10);
    }

    play(duration) {
        this.#progressRing.style.setProperty('--indicator-transition-duration', '0s');
        this.#progressRing.setAttribute('value', 0);

        setTimeout(() => {
            this.#progressRing.style.setProperty('--indicator-transition-duration', duration + 'ms');
            this.#progressRing.setAttribute('value', 100);
        }, 10);
    }

}


window.customElements.define('play-circle', PlayCircle);
window.customElements.define('carousel-element', CarouselElement);

